var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.comparisonGraph
    ? _c(
        "div",
        {
          staticClass: "py-6 px-6 flex-grow bg-pure-white rounded-xl",
          attrs: { id: _vm.comparisonGraph.id }
        },
        [
          _c(
            "div",
            { staticClass: "mb-5 flex gap-2" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "handle_comparison h-7.5 w-5 mr-1 flex items-center justify-center cursor-grab"
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-5 h-5",
                    attrs: { icon: "drag", color: "slate-6" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-wrap gap-2" },
                [
                  _vm.enableBranch
                    ? _c("BlInputSelect", {
                        attrs: { input: _vm.branchInput },
                        on: { changed: _vm.onChangeHandler }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlInputSelect", {
                    attrs: { input: _vm.calculationMethodInput },
                    on: { changed: _vm.onChangeHandler }
                  }),
                  _vm._v(" "),
                  _vm.useStage
                    ? _c("BlInputSelect", {
                        attrs: { input: _vm.stageInput },
                        on: { changed: _vm.onChangeHandler }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.useGroupBy
                    ? _c("BlInputSelect", {
                        attrs: { input: _vm.groupByInput },
                        on: { changed: _vm.onChangeHandler }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlInputFilter", {
                    attrs: {
                      activeLabel: _vm.dateActiveLabel,
                      title: "Date",
                      defaultValue: [_vm.defaultDate],
                      input: _vm.dateInput
                    },
                    on: { changed: _vm.onChangeDates }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlInputButton", {
                staticClass: "ml-auto",
                attrs: {
                  type: "plain-error",
                  dense: "",
                  icon: "delete",
                  title: "Delete comparison graph"
                },
                on: {
                  clicked: function($event) {
                    _vm.deleteOpened = true
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.fetchLoading
            ? _c("div", { staticClass: "h-64 grid place-content-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : _c(
                "div",
                { staticClass: "relative flex flex-col gap-5" },
                [
                  _vm.calculationMethodInput.model.value ===
                  "prospects_per_stage"
                    ? _c(
                        "div",
                        { staticClass: "px-8 flex items-center gap-2" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-600",
                            attrs: { text: "Total:" }
                          }),
                          _vm._v(" "),
                          _c("BlTextTitle4", {
                            staticClass: "text-slate-900",
                            attrs: { text: _vm.totalProspect }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-slate-600",
                            attrs: { text: "prospect(s)" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "px-8" },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Total final outcomes made during timeframe:"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("BlTextTitle4", {
                                    staticClass: "text-slate-900",
                                    attrs: { text: _vm.totalAdmitted }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-slate-600",
                                    attrs: { text: "Admitted" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.totalDiscontinued !== null
                                ? _c(
                                    "div",
                                    { staticClass: "flex items-center gap-2" },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "h-8 w-0.5 rounded bg-slate-300"
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextTitle4", {
                                        staticClass: "text-slate-900",
                                        attrs: { text: _vm.totalDiscontinued }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "text-slate-600",
                                        attrs: { text: "Discontinued" }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.calculationMethodInput.model.value ===
                  "prospects_per_stage"
                    ? _c("BarChart", {
                        attrs: {
                          labels: _vm.barChartDataProspect.labels,
                          datasets: _vm.barChartDataProspect.datasets,
                          stacked: "",
                          height: "12.5rem",
                          width: "calc((100vw - 15rem - 3.5rem) - 3rem)"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.calculationMethodInput.model.value === "final_outcomes"
                    ? _c("BarChart", {
                        attrs: {
                          labels: _vm.barChartDataFinal.labels,
                          datasets: _vm.barChartDataFinal.datasets,
                          stacked: "",
                          height: "12.5rem",
                          width: "calc((100vw - 15rem - 3.5rem) - 3rem)"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.calculationMethodInput.model.value === "conversion"
                    ? _c("BarChart", {
                        attrs: {
                          labels: _vm.barChartDataConversion.labels,
                          datasets: _vm.barChartDataConversion.datasets,
                          percentages: _vm.barChartDataConversion.percentages,
                          stacked: "",
                          height: "12.5rem",
                          width: "calc((100vw - 15rem - 3.5rem) - 3rem)",
                          oneBar: 128
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _vm.deleteOpened
            ? _c("BlBackdrop", {
                attrs: {
                  title: "Delete comparison graph",
                  label: "Delete",
                  description:
                    "You are about to delete comparison graph. Are you sure you want to proceed? This action is irreversible.",
                  type: "error",
                  empty: "",
                  disabled: _vm.deleteLoading
                },
                on: {
                  "backdrop-close": function($event) {
                    _vm.deleteOpened = false
                  },
                  "backdrop-action": _vm.onRemove
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d900584", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d900584","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/comparison/AcquisitionGraph.vue
// module id = null
// module chunks = 